import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';
import { useTheme } from '@mui/material/styles';
import { Box } from '@mui/material';
import { APP_URL } from '../config';

Logo.propTypes = {
  disabledLink: PropTypes.bool,
  sx: PropTypes.object,
};

export default function Logo({ disabledLink = false, sx }) {
  const theme = useTheme();
  const PRIMARY_LIGHT = theme.palette.primary.light;
  const PRIMARY_MAIN = theme.palette.primary.main;
  const PRIMARY_DARK = theme.palette.primary.dark;

  const logo = (
    <Box sx={{ width: '100%', height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', ...sx }}>
      <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 500.000000 500.000000">
        <defs>
          <linearGradient id="BG1" x1="100%" x2="50%" y1="9.946%" y2="50%">
            <stop offset="0%" stopColor={PRIMARY_DARK} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG2" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG3" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
        </defs>
        <g
          fill={PRIMARY_MAIN}
          stroke="none"
          strokeWidth="1"
          fillRule="evenodd"
          transform="translate(0.000000,500.000000) scale(0.100000,-0.100000)"
        >
          <path
            d="M2350 4704 c-19 -2 -78 -9 -130 -15 -173 -20 -404 -81 -570 -151
-430 -182 -765 -460 -1024 -848 -108 -161 -227 -430 -289 -650 -69 -244 -90
-661 -47 -915 82 -480 297 -901 632 -1236 323 -322 700 -520 1173 -614 125
-24 396 -49 456 -41 18 3 81 8 139 11 656 42 1302 417 1677 975 413 615 498
1390 227 2072 -184 465 -520 855 -958 1113 -234 138 -518 237 -801 280 -97 15
-414 27 -485 19z m371 -24 c435 -43 887 -231 1207 -503 372 -316 617 -703 732
-1154 53 -210 64 -305 64 -553 0 -236 -15 -362 -65 -558 -93 -363 -279 -694
-547 -974 -337 -352 -765 -577 -1252 -658 -188 -32 -518 -33 -695 -2 -153 26
-189 35 -305 70 -226 70 -391 148 -585 277 -450 299 -776 755 -914 1277 -59
221 -65 280 -66 568 0 276 5 327 55 535 87 360 284 719 548 996 469 493 1147
745 1823 679z"
          />
          <path
            d="M2045 4209 c-64 -14 -147 -41 -142 -46 3 -2 31 3 63 11 96 24 163 28
273 17 333 -35 549 -204 630 -492 11 -41 21 -93 21 -115 0 -46 14 -64 48 -64
25 0 62 16 62 28 0 4 -20 15 -44 25 l-45 18 -20 88 c-23 100 -53 174 -103 252
-32 49 -61 80 -141 153 -42 38 -182 102 -264 120 -78 17 -270 20 -338 5z"
          />
          <path
            d="M1321 3417 c-3 -130 71 -353 162 -487 106 -155 376 -358 712 -535 50
-26 126 -77 170 -114 44 -37 113 -93 153 -125 116 -94 207 -198 253 -290 29
-58 38 -71 33 -46 -9 48 -59 146 -102 200 -53 66 -135 143 -242 225 -52 41
-111 91 -132 113 -22 24 -59 48 -95 62 -71 28 -91 40 -268 154 -256 165 -398
285 -483 408 -80 116 -134 263 -151 412 -7 63 -9 66 -10 23z"
          />
          <path
            d="M1981 3380 c-13 -3 -29 -13 -35 -23 -9 -13 -6 -22 14 -41 27 -26 251
-178 398 -270 87 -55 95 -58 110 -42 12 12 18 39 21 97 3 71 6 81 25 88 11 4
190 7 396 6 305 -2 388 -5 442 -19 148 -35 239 -133 303 -330 l33 -101 36 -3
c33 -3 38 0 50 30 12 28 12 75 -1 318 -8 157 -15 286 -16 286 -5 5 -1756 9
-1776 4z"
          />
          <path
            d="M2089 2303 c-11 -13 -14 -123 -17 -601 l-2 -585 -43 6 c-141 20 -267
87 -387 207 -132 132 -200 272 -215 440 -10 123 -9 120 -60 120 -78 0 -76 15
-73 -476 l3 -429 42 -3 c35 -3 44 1 60 23 10 15 31 43 48 62 28 34 31 35 85
30 30 -3 125 -29 210 -58 85 -28 193 -59 240 -69 l85 -17 0 -114 0 -114 -102
-3 -101 -3 -16 -40 c-38 -94 -55 -90 385 -96 255 -3 393 -1 411 6 30 11 47 55
40 103 l-4 27 -112 3 -111 3 0 605 0 605 30 3 c70 8 72 45 6 104 -59 53 -370
278 -384 278 -3 0 -11 -7 -18 -17z"
          />
          <path
            d="M3213 1973 c-26 -9 -13 -30 15 -25 41 6 181 -26 211 -48 66 -47 114
-121 134 -205 2 -11 2 3 -1 30 -12 130 -98 222 -222 239 -80 11 -125 14 -137
9z"
          />
          <path
            d="M3584 1606 c1 -53 27 -69 58 -38 l22 22 -36 0 c-32 0 -37 3 -41 28
-3 17 -4 13 -3 -12z"
          />
          <path
            d="M3234 1470 c-28 -11 -38 -40 -20 -58 8 -8 40 -17 72 -21 31 -3 59
-11 61 -18 6 -18 -42 -27 -78 -14 -39 14 -59 14 -59 1 0 -32 132 -44 176 -15
47 30 24 56 -57 64 -48 4 -64 10 -64 21 0 12 13 14 68 12 70 -3 89 10 41 28
-31 12 -111 12 -140 0z"
          />
          <path
            d="M3435 1470 c-8 -13 5 -102 17 -117 18 -23 86 -35 122 -23 48 15 64
38 68 95 3 48 2 50 -22 50 -23 0 -25 -4 -28 -45 -2 -27 -9 -50 -19 -57 -40
-30 -93 -1 -88 47 2 14 1 33 -2 43 -5 18 -38 23 -48 7z"
          />
          <path
            d="M3680 1405 l0 -76 96 3 c77 2 99 6 107 20 8 12 7 21 -3 33 -8 10 -13
30 -12 46 4 38 -20 49 -112 49 l-76 0 0 -75z m148 28 c2 -9 -10 -13 -42 -13
-43 0 -63 10 -49 24 12 11 86 2 91 -11z m8 -54 c10 -16 -15 -29 -58 -29 -37 0
-54 12 -43 30 8 14 92 13 101 -1z"
          />
          <path
            d="M2578 1150 c-4 -14 -8 -51 -8 -83 0 -74 13 -80 85 -36 62 38 67 50 6
20 -65 -34 -70 -31 -73 52 -2 50 -5 64 -10 47z"
          />
        </g>
      </svg>
    </Box>
  );

  if (disabledLink) {
    return <>{logo}</>;
  }

  // Render as external link
  return (
    <a
      href={APP_URL}
      target="_blank"
      rel="noopener noreferrer"
      style={{ display: 'block', width: '100%', height: '100%' }}
    >
      {logo}
    </a>
  );
}
